export { TableOfContents as default } from './TableOfContents';
export type { TableOfContentsProps } from './TableOfContents.types';
